import { render, staticRenderFns } from "./SuiviDossier.vue?vue&type=template&id=73f1947f"
import script from "./SuiviDossier.vue?vue&type=script&lang=js"
export * from "./SuiviDossier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports